import Vue from 'vue'
import VueRouter from 'vue-router'

import TheProcess from "@/views/TheProcess";
import Admin from "@/views/Admin";
import store from "@/store/index";
import SignIn from "@/views/SignIn";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: TheProcess,
    meta: {requiresAuth: false}
  },
  {
    path: '/sign-in',
    name: 'Sign-In',
    component: SignIn,
    meta: {requiresAuth: false}
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {requiresAuth: true}
  },
  {
    path: "*",
    component: TheProcess,
    meta: {requiresAuth: false}
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach( (to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!store.state.user) {
      next('/sign-in');
    } else {
      next();
    }
  } else {
    next();
  }
});


export default router


